/**
 * Bilingual labels: English leads, Arabic follows as a quieter sub-label
 * ("Debit · مدين"), as the design system asks for on titles, columns and
 * key fields. With Arabic on, only the Arabic is shown.
 */
import { useCallback, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

export function useBi(): (key: string, opts?: Record<string, unknown>) => ReactNode {
  const { t, i18n } = useTranslation()
  const ar = i18n.language === 'ar'
  return useCallback((key: string, opts?: Record<string, unknown>) => {
    const main = t(key, opts) as string
    if (ar) return main
    const arabic = i18n.getFixedT('ar')(key, opts) as string
    if (!arabic || arabic === key || arabic === main) return main
    return (
      <>
        {main}
        <span lang="ar" style={{ fontFamily: 'var(--font-arabic)', fontWeight: 400,
                                 color: 'var(--ink-muted)' }}> · {arabic}</span>
      </>
    )
  }, [t, i18n, ar])
}
